import React from 'react';
import { useIntl } from 'react-intl';
import { US } from '../../common/constants';
interface IWarrantySection {
    name: string;
    defaultWarranty: number;
    selectedWarranty: number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    showExtendedWarranty: boolean;
    extendedWarranties: number[];
    country: string;
}

const WarrantySection = ({
    defaultWarranty,
    onChange,
    selectedWarranty,
    name,
    showExtendedWarranty,
    extendedWarranties,
    country,
}: IWarrantySection) => {
    const intl = useIntl();
    return (
        <>
            {((defaultWarranty && defaultWarranty > 0) ||
                showExtendedWarranty) && (
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="no-text-transform">Warranty</h2>
                    </div>
                    <div className="col-sm-12">
                        {(defaultWarranty || defaultWarranty > 0) && (
                            <div className="col-xs-12 col-sm-6 col-md-4">
                                <p
                                    className="color-select thumbnail"
                                    style={{
                                        borderColor: 'transparent',
                                    }}
                                >
                                    <label
                                        className="btn button-label disabled"
                                        style={{
                                            border: 'none',
                                            backgroundColor: '#e3f2fd',
                                            width: '250px',
                                        }}
                                    >
                                        {!defaultWarranty ||
                                        defaultWarranty <= 0
                                            ? 'N/A'
                                            : defaultWarranty.valueOf() > 1
                                            ? intl.formatMessage({
                                                  id: `${defaultWarranty}_Years`,
                                                  defaultMessage: `${defaultWarranty} Years`,
                                              })
                                            : intl.formatMessage({
                                                  id: `${defaultWarranty}_Year`,
                                                  defaultMessage: `${defaultWarranty} Year`,
                                              })}{' '}
                                        {intl.formatMessage({
                                            id: 'Default_Warranty',
                                            defaultMessage: 'Default Warranty',
                                        })}
                                    </label>
                                </p>
                            </div>
                        )}
                        {showExtendedWarranty &&
                            extendedWarranties &&
                            extendedWarranties!.map((warranty) => {
                                if (warranty !== 0)
                                    return (
                                        <div
                                            className="col-xs-12 col-sm-6 col-md-4"
                                            key={warranty}
                                        >
                                            <p
                                                className="color-select thumbnail"
                                                key={warranty}
                                                style={{
                                                    borderColor: 'transparent',
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    name={name}
                                                    id={warranty.toString()}
                                                    value={warranty}
                                                    checked={
                                                        warranty ===
                                                        selectedWarranty
                                                    }
                                                    onChange={onChange}
                                                />
                                                <label
                                                    className="btn button-label"
                                                    style={{
                                                        width: '250px',
                                                        whiteSpace: 'pre-wrap',
                                                    }}
                                                    htmlFor={warranty.toString()}
                                                >
                                                    {warranty === 0
                                                        ? intl.formatMessage({
                                                              id: 'No_Additional_Warranty',
                                                              defaultMessage:
                                                                  'No additional warranty',
                                                          })
                                                        : `Add ${
                                                              warranty.valueOf() >
                                                              1
                                                                  ? intl.formatMessage(
                                                                        {
                                                                            id: `${warranty}_years`,
                                                                            defaultMessage: `${warranty} years`,
                                                                        }
                                                                    )
                                                                  : intl.formatMessage(
                                                                        {
                                                                            id: `${warranty}_year`,
                                                                            defaultMessage: `${warranty} year`,
                                                                        }
                                                                    )
                                                          } ${intl.formatMessage(
                                                              {
                                                                  id: `Extended_Warranty`,
                                                                  defaultMessage: `extended warranty (additional fee applies)`,
                                                              }
                                                          )}`}
                                                </label>
                                            </p>
                                        </div>
                                    );
                            })}
                    </div>
                    {country === US && (
                        <div
                            className="col-md-12 mb-1"
                            style={{ marginBottom: '10px' }}
                        >
                            <em>
                                *For additional warranty options, check Warranty
                                Center.
                            </em>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default WarrantySection;
